import { useTranslation } from 'react-i18next';
import { useEffect } from 'react';
import { DefaultSelect } from '../../../../../../common/DefaultSelect/DefaultSelect';
import usePlanStore, {
  TVConfig,
} from '../../../../../../../../../store/planStore';

interface AdditionalAdvertisersSelectProps {
  copyIndex: number;
}

const zeroToTenAmount = 11;

const additionalAdvertisers = Array.from(
  { length: zeroToTenAmount },
  (_, i) => ({
    value: i,
    name: String(i),
  })
);

export default function AdditionalAdvertisersSelect({
  copyIndex,
}: AdditionalAdvertisersSelectProps) {
  const { t } = useTranslation();
  const { countryForms, selectedCountry, updateTVConfig } = usePlanStore();
  const formData =
    countryForms[selectedCountry!].offline?.tv?.copyForm[copyIndex];

  const handleChangeStateValues = (value?: string | number) => {
    if (!selectedCountry || !formData?.id) return;

    const newValue = value?.toString() ?? '0';
    const idParts = formData.id.split('_');

    if (idParts.length > 1) {
      idParts[1] = newValue;
    }

    const updatedId = idParts.join('_');

    updateTVConfig(
      selectedCountry,
      { copyForm: [{ additionalAdvertisers: newValue, id: updatedId }] },
      copyIndex
    );
  };

  useEffect(() => {
    if (!formData?.additionalAdvertisers) {
      handleChangeStateValues(String(0));
    }
  }, [formData?.additionalAdvertisers]);

  return (
    <DefaultSelect
      value={formData?.additionalAdvertisers ?? ''}
      onChange={(newValue) => handleChangeStateValues(String(newValue.value))}
      items={additionalAdvertisers || []}
      selectName={t('mediaPlanning.additionalAdvertisers')}
      labelId="additional-advertisers"
    />
  );
}
